module.exports = __webpack_public_path__ + "static/media/cyrex-GDC-20220327.8dc116ac.jpg";